<template>
  <div class="d-flex align-center">
    <v-btn icon @click="decreaseQuantity">
      <v-icon>mdi-minus</v-icon>
    </v-btn>
    <span>{quantity}</span>
    <v-btn icon @click="increaseQuantity">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  data() {
    return {
      quantity: 1,
    };
  },
  methods: {
    increaseQuantity() {
      this.quantity++;
    },
    decreaseQuantity() {
      if (this.quantity > 1) this.quantity--;
    },
  },
};
</script>
